import { studentAddApi } from "../../api/student/studentAddApi"

type PayloadShape = Parameters<typeof studentAddApi>[0]

export async function studentAddService(payload: PayloadShape, token: string) {
	payload.studentNo = +payload.studentNo
	return await studentAddApi(payload, token)
}
